import DOMPurify from 'dompurify';
import React from 'react';

import {isError} from 'graphql-client/Error';
import getTestProps from 'test/lib/cypress/getTestProps';
import useResizeSVG from 'ui-library/hooks/useResizeSVG';

export type ChemicalStructureImageData =
  | {__typename: 'SVGNode'; base64Svg: string}
  | {__typename: 'ErrorNode'; message: string};

function ChemicalStructureSVG({
  chemicalStructureImage,
  className,
  svgClassName,
}: {
  chemicalStructureImage: ChemicalStructureImageData;
  className?: string;
  svgClassName?: string;
}): JSX.Element {
  const base64Svg = !isError(chemicalStructureImage) ? chemicalStructureImage.base64Svg : null;
  const errorMessage = isError(chemicalStructureImage) ? chemicalStructureImage.message : null;

  // The chemistry service always returns square SVGs with lots of unnecessary vertical padding, causing most
  // chemicals to show up smaller. There's no way to modify the SVG's viewBox if it's included as an <img>,
  // but it is possible if the SVG is included as raw HTML (dangerouslySetInnerHTML).
  const svgContainerRef = useResizeSVG<HTMLDivElement>(svgClassName);

  if (base64Svg) {
    const htmlSvg = DOMPurify.sanitize(window.atob(base64Svg));
    return (
      <div
        ref={svgContainerRef}
        className={className}
        {...getTestProps({component: 'ChemicalStructureSVG', element: 'root', key: 'wrapper'})}
        // oxlint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{__html: htmlSvg}}
      />
    );
  } else {
    return (
      <div {...getTestProps({component: 'ChemicalStructureSVG', element: 'root', key: 'error'})}>
        {errorMessage}
      </div>
    );
  }
}

export default React.memo(ChemicalStructureSVG);
